import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  .component-title {
    font-size: 1.6rem;
    color: var(--primary_color);
    padding-top: 1rem !important;
  }

  .grid,
  .product-carousel,
  .mosaico {
    margin-top: 2rem;
  }

  .insufficient-items .swiper-wrapper {
    justify-content: space-around;
  }

  @media (max-width: 1200px) {
    .component-title {
      padding: 0 1rem;
    }
  }

  @media (max-width: 726px) {
    .simple-swiper .swiper-button-prev,
    .simple-swiper .swiper-button-next {
      display: none;
    }
  }
`;
